<!-- HEADER — Exactly like Mockup -->
<header class="header" [class.scrolled]="isScrolled">
  <div class="header-inner container">

    <!-- Logo -->
    <a routerLink="/" class="logo">
      <img src="assets/images/logo-dmed.jpg" alt="D-Med Express" class="logo-img">
    </a>

    <!-- Navigation links -->
    <nav class="nav-desktop">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link">Accueil</a>
      <a routerLink="/prescription/upload" routerLinkActive="active" class="nav-link">Commander</a>
      <a routerLink="/catalog" routerLinkActive="active" class="nav-link">Catalogue</a>
      <a routerLink="/patient/dashboard" routerLinkActive="active" class="nav-link">Suivi</a>
      <a routerLink="/chat" routerLinkActive="active" class="nav-link">Aide</a>
    </nav>

    <!-- Header Actions -->
    <div class="header-actions">
      <!-- Address selector -->
      <div class="location-badge">
        <span class="location-dot"></span>
        <span class="location-label">Cocody, Abidjan</span>
        <span class="location-arrow">▼</span>
      </div>

      <!-- Basket / Cart -->
      <a routerLink="/cart" class="basket-badge-btn" aria-label="Panier">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
        </svg>
        <span class="basket-counter">3</span>
      </a>

      <!-- Connexion -->
      @if (currentUser$ | async; as user) {
        <div class="user-chip-header">
          <a routerLink="/profile" class="user-avatar-pill">
            {{ user.firstName ? user.firstName.charAt(0) : '' }}{{ user.lastName ? user.lastName.charAt(0) : '' }}
          </a>
          <button (click)="logout()" class="logout-btn-header" title="Déconnexion">✕</button>
        </div>
      } @else {
        <a routerLink="/login" class="btn-connexion-mock" id="header-login">Connexion</a>
      }
    </div>

  </div>
</header>